<script lang="ts" setup="">
import WidgetIcon from '~/assets/icons/widget/widget.svg'
import ArrowUpIcon from '~/assets/icons/widget/top-btn.svg'
import CloseIcon from '~/assets/icons/widget/close.svg'
import TGIcon from '~/assets/icons/widget/tg.svg'
import PhoneIcon from '~/assets/icons/widget/phone.svg'
import WidgetPhoneModal from '~/entities/bitrix/WidgetPhoneModal.vue'
import useMainStore from '~/shared/store'

const isWidgetOpen = ref(false)
const mainStore = useMainStore()
const toggleWidget = () => isWidgetOpen.value = !isWidgetOpen.value
const slideUp = ()  => window.scrollTo(0, 0)

const closeWidget = () => isWidgetOpen.value = false

function handlePhone() {
  mainStore.setBitrixModalState(true)
  closeWidget()
}
</script>

<template>
  <div class="bitrix-widget" :class="isWidgetOpen && 'open'">
    <div class="bitrix-widget__buttons">
      <div
        class="bitrix-widget__up"
        :class="isWidgetOpen && 'disabled'"
        @click="slideUp">
        <ArrowUpIcon/>
      </div>
      <Transition name="slide-up">
        <div class="bitrix-widget__buttons-container" v-if="isWidgetOpen">
          <div class="bitrix-widget__buttons-phone" @click="handlePhone">
            <PhoneIcon/>
          </div>
          <a href="https://t.me/+79213976735" target="_blank" ref="noopener noreferrer" class="bitrix-widget__buttons-tg" @click="closeWidget">
            <TGIcon/>
          </a>
        </div>
      </Transition>
      <div class="bitrix-widget__main">
          <div
            v-if="!isWidgetOpen"
            class="bitrix-widget__button bitrix-widget__button_open"
          >
            <Transition name="pulse">
              <div class="bitrix-widget__button-pulse"></div>
            </Transition>
            <WidgetIcon
              @click="toggleWidget"
            />
          </div>
          <div
            class="bitrix-widget__button bitrix-widget__button_close"
            v-else
            @click="toggleWidget"
          >
            <CloseIcon />
          </div>
      </div>
    </div>
    <Teleport to="body">
      <WidgetPhoneModal/>
    </Teleport>
  </div>
</template>

<style lang="scss" scoped>
.bitrix-widget {
  display: flex;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 1000;
  padding: 30px 70px;
  align-items: flex-end;
  justify-content: flex-end;
  flex-direction: column;
  pointer-events: none;
  overflow: visible;
  transition: background-color .3s;
  @include md-breakpoint {
    padding: 0 10px 88px;
  }

  svg{
    width: 100%;
  }

  &.open {
    background-color: #0000001A;

    .bitrix-widget__buttons-container {
      z-index: 1;
    }
    .bitrix-widget__button_close {
      z-index: 1;
    }
  }

  &__up {
    position: absolute;
    bottom: calc(100% + 16px);
    left: 0;
    width: 56px;
    height: 56px;
    flex-shrink: 0;
    display: flex;
    transition: opacity .3s, background-color .3s;
    cursor: pointer;
    pointer-events: auto;
    @include md-breakpoint {
      width: 48px;
      height: 48px;
    }

    &.disabled {
      opacity: .5;
      pointer-events: none;
    }

    &:hover:not(:active) {
      @include mf-breakpoint {
        svg {
          :deep(path[fill="#EB5A0A"]) {
            fill: $control-bg_primary-hover;
          }
        }
      }
    }
  }

  &__button {
    pointer-events: auto;
    width: 56px;
    height: 56px;
    z-index: 2;
    @include md-breakpoint {
      width: 48px;
      height: 48px;
    }

    &:hover:not(:active) {
      @include mf-breakpoint {
        svg {
          :deep(path[fill="#EB5A0A"]) {
            fill: $control-bg_primary-hover;
          }
        }

        .bitrix-widget__button-pulse {
          border-color: $control-bg_primary-hover;
        }
      }
    }

    &_close {
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 4px 20px 0 #00000014;
      border-radius: 50%;
      background-color: $white;

      svg {
        width: auto;
      }

      &:hover:not(:active) {
        @include mf-breakpoint {
          :deep(svg) {
            :deep(path[fill="#EB5A0A"]) {
              fill: $control-bg_primary-hover;
            }
          }
        }
      }
    }

    &-pulse {
      pointer-events: none;
      width: 100%;
      height: 100%;
      border: 1px solid $control-content_orange;
      position: absolute;
      z-index: 1;
      animation: 1.8s ease-in-out infinite pulse;
      border-radius: 50%;
    }
  }

  &__main {
    position: relative;
    cursor: pointer;
  }

  &__buttons {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;

    &-container {
      position: absolute;
      bottom: calc(100% + 8px);
      pointer-events: auto;

      a, .bitrix-widget__buttons-phone {
        cursor: pointer;

        &:hover:not(:active) {
          @include mf-breakpoint {
            svg {
              :deep(path[fill="#EB5A0A"]) {
                fill: $control-bg_primary-hover;
              }
            }
          }
        }
      }
    }
  }
}

@keyframes  pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  50% {
    transform: scale(1.2);
    opacity: .6;
  }
  100% {
    transform: scale(1.4);
    opacity: 0;
  }
}
</style>
